<template>
  <div class="ExternalSearchRequestComponent">
    <p v-if="canCreateElement == false">{{ lang.infotext_3 }}</p>
    <p v-if="canCreateElement == true && type != 'part'">{{ lang.infotext_4 }}</p>
    <span v-if="canCreateElement && type == 'part'">
      <span v-show="!searchEngineExists">{{ searchStringManufacturer }}{{ searchStringManufacturerPartNumber }}{{ providers }}
      <p>{{ lang.infotext_1 }}</p>
    </span>
    <span v-show="searchEngineExists">
      <p>{{lang.infotext_2}}:</p>
      <div class="text-center"   v-show="searchStatus">
        <b-spinner variant="white" :label="lang.loader_Search"></b-spinner>
        <p>{{lang.loader_Search}}...</p>

      </div>
      <div v-show="searchError">{{lang.searchError}}<br><br></div>
      <div v-show="!searchStatus">

        <b-form-input
          type="text"
          @keyup.enter="searchOutside"
          :placeholder="lang.input_placeholder_Manufacturer"
          v-model="searchStringManufacturer" >
        </b-form-input><br>
        <b-form-input
          type="text"
          @keyup.enter="searchOutside"
          :placeholder="lang.input_placeholder_ManufacturerPartNumber"
          v-model="searchStringManufacturerPartNumber" >
        </b-form-input><br>

        <b-form-group>

          <b-form-checkbox-group
            stacked
            v-model="providers"
            name="searchparts"
            :options="searchEngines"
            class="ml-4"
            aria-label="Search parts"
          ></b-form-checkbox-group>
        </b-form-group>


        <div>
          <b-button @click="searchOutside" size="sm" class="my-2 my-sm-0 button" :variant="variant" :disabled="providers.length == 0">{{lang.button_Search}}</b-button>
          <b-button @click="reset" size="sm" class="my-2 my-sm-0 button" :variant="variant">{{lang.button_Reset}}</b-button>
        </div>

      </div>
      <br>
    </span>
    </span>
    
 </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: 'ExternalSearchRequestComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {


  },
  data () {
    return {
      id: "ExternalSearchRequestComponent",
      searchEngineExists: false,
      searchStatus: false,
      searchError: false,
      providers: [],
      searchEngines: [],
      searchStringManufacturer: "",
      searchStringManufacturerPartNumber: "",
      requestDetails: null
    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',


    }),
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    requestId() {
      return this.$route.query.requestId;
    },
    canCreateElement() {
      return this.$store.getters.requestDetails.canCreateElement;
    },
    type() {
      return this.$store.getters.requestDetails.type;
    },
  },
  created () {
    let vue = this;

    this.getRequest();

    this.$store.dispatch("getSearchEnginesBasic")
    .then((result) => {
      console.log(result)
      if (result.status == "OK"){
        if (result.data.length > 0) {
          
          for (let i = 0, lei = result.data.length; i < lei; i++) {
              if (result.data[i].IsActive == true) {
                if (result.data[i].Name !== "Ultra Librarian") {
                  vue.searchEngines.push(result.data[i].Name);
                }
              }
            }
          if (vue.searchEngines.length > 0) {
              vue.searchEngineExists = true;
              
            } else {
              vue.searchEngineExists = false;
            }
            
        } else {
          vue.searchEngineExists = false;
        }
        

      }


    })

  },
  watch: {
    
    providers: function (new_Val, old_Val) {

      let obj = {
        searchString: this.searchString,
        choosenProviders: this.providers
      }
      //this.$store.dispatch("setSearchingRequestObject", obj);

    },
    searchStringManufacturer: function () {

      let obj = {
        searchStringManufacturer: this.searchStringManufacturer,
        searchStringManufacturerPartNumber: this.searchStringManufacturerPartNumber,
        choosenProviders: this.providers
      }
      //this.$store.dispatch("setSearchingRequestObject", obj);

    },
    searchStringManufacturerPartNumber: function () {

      let obj = {
        searchStringManufacturer: this.searchStringManufacturer,
        searchStringManufacturerPartNumber: this.searchStringManufacturerPartNumber,
        choosenProviders: this.providers
      }
      //this.$store.dispatch("setSearchingRequestObject", obj);

    },
    reloadedAfterActionComplex: {
        handler: function (newValue) {

          for (let el in newValue) {

            if (newValue[el].name == this.id) {
              if (newValue[el].status == true) {

                this.getRequest();

                newValue[el].status = false;

                this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
              }
            }
          }
        },
        deep: true

      },

  },
  
  methods: {
    
    reset() {
      this.searchStringManufacturer = "";
      this.searchStringManufacturerPartNumber = "";
      this.providers = [];
      var obj = {
        searchStringManufacturer: "",
        searchStringManufacturerPartNumber: "",
        choosenProviders: []
      }
      //this.$store.dispatch("setSearchingRequestObject", obj);
    },
    searchOutside(){
      this.searchError = false;
      this.searchStatus = true


      var obj = {
        manufacturerName: this.searchStringManufacturer.trim(),
        manufacturerPartNumber: this.searchStringManufacturerPartNumber.trim(),
        choosenProviders: this.providers
        }
      // this.$store.dispatch("setSearchingRequestObject", obj);

      

      let _vue = this

      this.$store.dispatch("pm_searchByMPN", obj)
        .then(function(result){

          
          if (result != undefined){
            console.log(result)



            if (result.status == "OK"){

              _vue.$store.dispatch("externalSearchResponse", result.data);

              _vue.searchStatus = false;


              _vue.goto();



            }else{

              const obj = {
                text: _vue.lang.alert_error_Searching + ": " + result.message,
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

              
              _vue.searchStatus = false;
              _vue.searchError = true;
            }
          }else{
         
            _vue.searchStatus = false;
            _vue.searchError = true;
          }


      })

    },
    goto(goalObj) {

      let to = "/PartManager/PartSearch";

      this.$store.dispatch("editPropertiesForm", false);

      

      let routingObject = {
        from: this.$route.path,
        to: to,
        requestId: this.requestId,
        //id: id,
        sourceType: "details",
        sourceId: "",
        sourceRevisionId: "",
        end: false
      }

      let obj = {
        col___revisionId: {
          revisionId: "",
          partId: ""
        },
        col___revision: {
          revisionId: ""

        },
        col___status: {
          assembly: false

        }
      }

      this.$store.dispatch("setSelectedRows", [obj]);

      

      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      this.$router.push({ path: to, query: routingObject });
      
    },
    getRequest() {

      let vue = this;

      let obj = {
        requestId: this.$route.query.requestId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRequest', obj)
          .then((result) => {
            console.log(result)
            if (result.status == "OK") {

              if (result.data != null) {
                vue.requestDetails = result.data;
              }

              

              this.searchStringManufacturer = vue.requestDetails.manufacturer;
              this.searchStringManufacturerPartNumber = vue.requestDetails.manufacturerPartNumber;
              
            }
            
        })

      
    }

  }
}
</script>


<style lang="scss">
  .ExternalSearchRequestComponent{
    .searching{
      margin-left: 50px;
      margin-top: 20px;
    }
    .button{
      margin-left: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ExternalSearchRequestComponent.vue